import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import * as LoginStore from './loginStore';
import { renderNewTextField } from "../common/forms/FieldCreators"
import { Form, Control } from 'react-redux-form';
import { connect } from 'react-redux';
import { Location } from 'history';
import { localizations } from '../localization/localization';
import FormItem from '../components/forms/FormItem'
import { ApplicationState } from '../store';

type LoginFormProps = typeof LoginStore.actionCreators & LoginStore.LoginState & { location: Location };

interface AuthorizeHeader { 'Authorize': string; }

const LoginForm: React.StatelessComponent<LoginFormProps> = (props) => {
    return (
        <Form model="loginForm" onSubmit={values => props.loginRequest(values, props.location)}>
            <Grid container direction="column" justify="center" alignItems="center">
                <Grid item><Control.input type="hidden" model=".grant_type" value="password" /></Grid>
                <Grid item style={{ width: 300 }}> <FormItem><Control.text model=".email" component={renderNewTextField} label={localizations.login.email} /></FormItem></Grid>
                <Grid item style={{ width: 300 }}> <FormItem><Control.text type="password" model=".password" component={renderNewTextField} label={localizations.login.password} /></FormItem></Grid>
                <Grid item>
                    <br />
                    <br />
                </Grid>
                <Grid item><Button variant="contained" type="submit" color="secondary">{localizations.login.submitLogin}</Button></Grid>
            </Grid>
        </Form>
    );
};

const mapStateToProps = (state: ApplicationState) => state.login;

export default connect(mapStateToProps, LoginStore.actionCreators)(LoginForm);



// WEBPACK FOOTER //
// ./src/login/LoginForm.tsx